import { DIGISAKA_API_ORIGIN } from './digisakaApiOrigin';

/**
 * Digisaka FastAPI metered `/api/*` — use with `fetch` and `digisakaAuthRequestInit`.
 * JWT auth is via httpOnly cookies (not Authorization headers from localStorage).
 */
export const DIGISAKA_API_TREEDETECTION = `${DIGISAKA_API_ORIGIN}/api/treedetection`;
export const DIGISAKA_API_CROWN_SEGMENTATION = `${DIGISAKA_API_ORIGIN}/api/crown-segmentation`;
export const DIGISAKA_API_FIELDDELINEATION = `${DIGISAKA_API_ORIGIN}/api/fielddelineation`;
export const DIGISAKA_API_BLS_FORECAST = `${DIGISAKA_API_ORIGIN}/api/bls-forecast`;

/** Present on responses from metered inference routes so the UI can update budget without extra /auth/me calls. */
export const INFERENCE_COMPUTE_MS_HEADER = 'x-digisaka-compute-ms';

/** Spread into every authenticated `fetch` to Digisaka FastAPI (sends httpOnly JWT cookies). */
export function digisakaAuthRequestInit(init: RequestInit = {}): RequestInit {
  return {
    credentials: 'include',
    ...init,
  };
}

/** JSON POST (viewport). */
export function gptInferenceJsonHeaders(): HeadersInit {
  return {
    'Content-Type': 'application/json',
  };
}

/** Multipart (FormData): do not set Content-Type — browser sets boundary. */
export function gptInferenceMultipartAuthHeaders(): HeadersInit {
  return {};
}

/** Optional extra headers for metered GET/POST/SSE routes. */
export function digisakaMeteredAuthHeaders(): HeadersInit {
  return {};
}
